import {createContext} from 'react'

export interface PreviousMedicalReportContextProps {
    previousReport?: string
}

export const PreviousMedicalReportContext = createContext<PreviousMedicalReportContextProps | undefined>(undefined)

export const PreviousMedicalReportProvider = PreviousMedicalReportContext.Provider
